import { Box, CircularProgress } from '@mui/material'
import React from 'react'
import { commonCss } from '../StyleConfig/CommonCss'

const Loading = () => {
  return (
    <Box sx={{display:"flex",width:"100%",height:"40vh",alignItems:"center",justifyContent:"center"}}>
        <CircularProgress disableShrink sx={{color:commonCss.green}} />
    </Box>
  )
}

export default Loading